import { isEqual } from 'lodash';
import { useCallback } from 'react';
import { SearchOption, SearchQuery } from '../../../cookbook/SearchField/SearchField.helper';

export interface UseAddToQueryArguments {
  searchQuery: SearchQuery;
  setQuery: (query: SearchQuery) => void;
}

export type OnSearchCallback = () => void;

export const scrollToTop = () => window.scrollTo(0, 0);
export const scrollIntoView = () => document.body.scrollIntoView({ behavior: 'smooth' });

export const useAddToQuery = ({ searchQuery, setQuery }: UseAddToQueryArguments, onSearch: OnSearchCallback = scrollIntoView) =>
  useCallback(
    (option: SearchOption) => {
      if (!searchQuery.find((queryOption) => isEqual(option, queryOption))) {
        setQuery([...searchQuery, option]);
        onSearch();
      }
    },
    [searchQuery, setQuery, onSearch]
  );
